import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ProductDetailsGQL, ProductDetailsQueryVariables, ProductDetailsQuery } from 'src/gql/generated';
import { gqlErrors } from 'src/app/utils/gql-errors';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(
    private http: HttpService,
    private productDetailGQL: ProductDetailsGQL,
  ) {}

  public async fetchProducts(
    body: ProductDetailsQueryVariables,
    success: (resp: ProductDetailsQuery) => void,
    error?: any,
  ) {
    const resp = await this.productDetailGQL.fetch({ variables: body, fetchPolicy: 'network-only' }).toPromise();
    if (gqlErrors(resp)) {
      if (this.http.hasExtensions(gqlErrors(resp))) {
        error(gqlErrors(resp)[0].extensions);
      } else {
        this.http.handleError();
      }
    } else {
      success(resp.data);
    }
  }
}
